import * as Sentry from "@sentry/react";
import cookie from "cookie";
import { useEffect } from "react";
import { OpenAPI } from './api';
import { request as __request } from './api/core/request';
import { AuthProvider } from "./auth/AuthContext";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";

// This interceptor will work on requests made via OpenAPI
OpenAPI.interceptors.request.use((request) => {
  const unsafeMethods = ['post', 'put', 'patch', 'delete'];
  const method = request.method.toLowerCase();
  
  if (unsafeMethods.includes(method)) {
    const csrftoken = cookie.parse(document.cookie).csrftoken;
    // console.log(csrftoken);
    if (csrftoken) {
      request.headers["X-CSRFTOKEN"] = csrftoken;
    }
  }
  return request;
});

const App = () => {
  useEffect(() => {
    const setCsrfCookie = async () => {
      try {
        // This now calls your specific /csrf endpoint
        await __request(OpenAPI, {
          method: "GET",
          url: "/common/csrf",
        });
      } catch (error) {
        console.error("Could not set CSRF cookie:", error);
      }
    };
    setCsrfCookie();
  }, []);

  return (
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/login" replace /> } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
